import { createAsyncThunk } from '@reduxjs/toolkit'
import { cashOutBet, getPreviousRoundState, KickCount, placeBet } from '../PenaltyShootout.services'
import { BET_RESULT } from 'utils/constants/index'
import { heroDeflect } from '../PixiGame/MagicaSpell/bridge'

import { hitSfx, lossSfx, winSfx } from '../PixiGame/MagicaSpell/soundManager'
import { openSuccessToaster } from 'utils/common-services/toaster.service'

export const magicaSpellGamePreviousRoundState = createAsyncThunk(
  'magicaSpell/get-previous-round-states', async (_, thunkApi) => {
    try {
      const res = await getPreviousRoundState()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const magicaSpellGamePlacedBet = createAsyncThunk(
  'magicaSpell/place-bet', async ({ payload, buttonAudio }, thunkApi) => {
    try {
      const res = await placeBet(payload)
      const { gameSound } = thunkApi?.getState()?.gameSetting
      openSuccessToaster({ message: 'Bet Placed' })
      gameSound && buttonAudio?.play()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const magicaSpellGameCashOut = createAsyncThunk(
  'magicaSpell/cash-out', async (_, thunkApi) => {
    try {
      const res = await cashOutBet()
      const { gameSound } = thunkApi?.getState()?.gameSetting
      gameSound && winSfx?.play()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const magicaSpellKickCount = createAsyncThunk(
  'magicaSpell/kick-count', async (payload, thunkApi) => {
    try {
      const { roundNumber, onSuccess } = payload
      const res = await KickCount({ roundNumber })
      const { gameSound } = thunkApi?.getState()?.gameSetting
      if (res.result === BET_RESULT.LOST) {
        heroDeflect(res)
        gameSound && lossSfx?.play()
      } else {
        gameSound && hitSfx?.play()
      }
      onSuccess(res)
      res.roundNumber = payload.roundNumber
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)
